import { useState } from "react";

interface FaqItem {
  question: string;
  answer: string;
}

interface LocalFaqProps {
  city: string;
  faqs: FaqItem[];
}

export default function LocalFaqSection({ city, faqs }: LocalFaqProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((f) => ({
      "@type": "Question",
      "name": f.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": f.answer,
      },
    })),
  };

  return (
    <section className="py-20 bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">
            Questions fréquentes
          </span>
          <h2 className="mt-3 text-3xl font-bold text-stone-900">
            FAQ Carrelage à {city}
          </h2>
          <p className="mt-3 text-sm text-stone-500 max-w-xl mx-auto">
            Les questions qu&apos;on nous pose le plus souvent pour nos interventions à {city} et dans les environs.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="border border-stone-200 rounded-lg overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm font-semibold text-stone-900 pr-3">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-amber-700 flex-shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-stone-500 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}